import * as React from "react";

export const EmptyElement: React.FC = () => (
  <span className="map-element map-element--empty" />
);
;
import "/Users/jekri/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";